import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  #pagination;

  connectedCallback() {
    super.connectedCallback();
    const navigation = this.querySelector('[data-ratgeber-pagination]');
    if (!navigation) return;
    // A numbered link selects this SSR page. The top sentinel is already visible
    // on arrival; auto-prepending would immediately replace that URL with N - 1.
    // Earlier Ratgeber pages remain available through the real previous link.
    const previous = this.refs.viewMorePrevious;
    if (previous) {
      this.infinityScrollObserver?.unobserve(previous);
      // A queued observer callback compares its target against the current refs.
      previous.removeAttribute('ref');
      this.updatedCallback();
    }
    import(navigation.dataset.paginationModule)
      .then(({ RatgeberPagination }) => {
        if (!this.#pagination && this.isConnected && navigation.isConnected) {
          this.#pagination = new RatgeberPagination(navigation);
        }
      })
      .catch(() => {
        // Fall back to SSR page navigation if the floating enhancement cannot load.
        // Stop auto-pagination so the server-rendered active page stays accurate.
        this.infinityScrollObserver?.disconnect();
      });
  }

  updatedCallback() {
    super.updatedCallback();
    // The shared renderer updates history immediately after this callback.
    this.#pagination?.scheduleUpdate();
  }

  disconnectedCallback() {
    this.#pagination?.destroy();
    this.#pagination = undefined;
    super.disconnectedCallback();
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
